export const getTimezoneName = () => {
  // Pass 'en' to satisfy locale enforcement in tests. The locale parameter
  // does NOT affect timezone detection - resolvedOptions().timeZone always
  // returns the system timezone regardless of which locale is passed.
  const name = Intl.DateTimeFormat('en').resolvedOptions().timeZone;

  // In Lambdatest app test (Android device) a value of '+00:00' is returned
  // as a timezone name if the Lambdatest device Time Zone property is
  // set to GMT or UTC. Such name is not listed in IANA timezone names and is
  // not recognized as a valid timezone identifier by PROSE (Rust library),
  // hence the override to supported "UTC" name.
  // Details in HUB-1129 issue.
  return name === '+00:00' ? 'UTC' : name;
};
